export default {"src":"/_next/static/media/text-size.42cd091b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};